import { lazy } from "react";
import Loadable from "app/components/Loadable";

const EmployeeAttendance = Loadable(lazy(() => import("./EmployeeAttendance")));

const EmployeeAttendanceRoutes = [
  { path: "/employee/attendance", element: <EmployeeAttendance /> },
];

export default EmployeeAttendanceRoutes;
